
const _ = require('lodash');

const kv = require('knockout.validation');

const vb = require('./definition');

const {
	unwrapParamsAccessor,
} = require('./util');


function nativeRuleValidationBuilderFactory (rule) {
	return (paramsAccessor, customMessage = false) => {
		return {
			validator: (v) => {
				const params = unwrapParamsAccessor(paramsAccessor);
				return rule.validator(v, params);
			},
			message: (_garbageParams, observable) => {
				const params = unwrapParamsAccessor(paramsAccessor);
				return kv.formatMessage(customMessage || rule.message, params, observable);
			},
		};
	};
}

_.each(kv.rules, (rule, name) => {
	name = ({
		min: 'numberMin',
		max: 'numberMax',
	}[name]) || name;
	vb[name] = nativeRuleValidationBuilderFactory(rule);
});

vb.numberCeil = (message) => {
	return vb.all([
		vb.number(),
		vb.custom((v) => {
			v = Number(v);
			return !isNaN(v) && (v % 1) === 0;
		}, message || 'Только целые числа'),
	]);
};